import { cn } from "@bem-react/classname"
import Help from "components/Help"
import { selectCatalog, setCatalogType, getType} from "modules/Catalog"
import { selectorIsUAExam } from "modules/Exam/selectors"
import { FC } from "react"
import { useDispatch, useSelector } from "react-redux"
import "./TypeSelector.scss"

const TypeSelector: FC = () => {
    const dispatch = useDispatch()
    const data = useSelector(selectCatalog)
    const catType = getType(data)
    const cnTypeSel = cn('TypeSelector')
    const cnType = cn('Type')
    const setType = (name:string) => ()=>dispatch(setCatalogType(name))
    const isUAExam = useSelector(selectorIsUAExam)
    if (!data.catalogTypes) {
        return <></>
    }
    return <div className={cnTypeSel()}>{isUAExam ? `Каталог завдань` : `Каталог заданий`}{data.catalogTypes.map((el, index) => <span key={index} onClick={setType(el.name)} className={catType.name === el.name?cnType('active'): cnType()}>{el.title}</span>)} <Help name="prob_catalog"/></div>
}

export default TypeSelector